module.exports = {
  REPATRIATIONS_TRANSACTIONS_CONFIRM_REQUEST: 'REPATRIATIONS_TRANSACTIONS_CONFIRM_REQUEST',
  REPATRIATIONS_TRANSACTIONS_CONFIRM_SUCCESS: 'REPATRIATIONS_TRANSACTIONS_CONFIRM_SUCCESS',
  REPATRIATIONS_TRANSACTIONS_CONFIRM_FAILURE: 'REPATRIATIONS_TRANSACTIONS_CONFIRM_FAILURE',
};
